<div
  class="relative flex w-full items-center justify-between border-b border-solid border-border-2 px-6 py-1 xl:h-header xl:py-[15px]"
>
  <button
    class="!flex !h-6 !w-[40px] !items-center !justify-center !rounded-none !border !border-solid !border-black/[.04] !leading-none xl:!h-8 xl:!w-[72px]"
    (click)="onBack()"
  >
    <ng-icon name="featherChevronLeft" />
  </button>

  <div class="absolute left-20 top-1/2 -translate-y-1/2 xl:left-1/2 xl:-translate-x-1/2">
    <app-search />
  </div>

  <div class="my-0 flex items-center space-x-4">
    <app-promo-popup-trigger />

    <ng-container *ngTemplateOutlet="ctaButton?.templateRef ?? null" />

    <app-history-trigger />

    <app-notification></app-notification>

    @if (isAdmin()) {
      <button id="help-btn" mat-icon-button [matMenuTriggerFor]="adminSupportMenu">
        <mat-icon>add</mat-icon>
      </button>
    } @else {
      <button id="help-btn" mat-icon-button [matMenuTriggerFor]="supportMenu">
        <mat-icon>question_mark</mat-icon>
      </button>
    }
  </div>
</div>

<mat-menu #supportMenu="matMenu">
  <a class="h-10" [href]="helpCentreUrl" target="_blank" mat-menu-item data-cy="header-help-centre">
    {{ 'help-centre' | translate }}
  </a>
  <a class="h-10" [href]="privacyPolicyUrl" target="_blank" mat-menu-item>
    {{ 'privacy-policy' | translate }}
  </a>
  <button class="h-10" (click)="onContactSupport()" mat-menu-item data-cy="header-contact-support">
    {{ 'contact-us' | translate }}
  </button>
  <button class="h-10" (click)="onOnboarding()" [disabled]="onboardingReactivating()" mat-menu-item>
    {{ 'common.onboarding' | translate }}
  </button>
</mat-menu>

<mat-menu #adminSupportMenu="matMenu">
  <button mat-menu-item mainClass="h-10" (click)="onNew()">{{ 'notification.compose' | translate }}</button>
</mat-menu>
